import * as React from "react";
const SvgFiRrFaceThermometer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-thermometer_svg__a)">
      <path
        fill="#062147"
        d="M23.182 16.364C21.37 21.003 16.982 24 12 24 5.38 24-.004 18.617-.004 12s5.383-12 12-12c3.597 0 6.97 1.59 9.261 4.363a1 1 0 0 1-1.543 1.274A9.97 9.97 0 0 0 12 2C6.482 2 1.996 6.486 1.996 12s4.486 10 10 10a9.94 9.94 0 0 0 9.322-6.364 1 1 0 0 1 1.863.727zM9.997 9.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.997 9.5m5.5 1.5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 15.497 11m-1.417 3.316A7.4 7.4 0 0 0 11.996 14c-3.107 0-5.563 2.162-5.666 2.254a.999.999 0 0 0 1.33 1.493c.02-.018 2.005-1.748 4.336-1.748 1.5 0 2.854.715 3.637 1.23.428.282.991.247 1.367-.102l1.162-1.077-.819-.939a1 1 0 0 1 1.5-1.322l.82.939 1.645-1.45-.834-.956a1 1 0 0 1 1.5-1.322l.834.956.435-.383c.747-.658.988-1.779.457-2.622a2.002 2.002 0 0 0-3.024-.448l-6.598 5.81z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-thermometer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceThermometer;
